<mat-form-field floatLabel="auto" subscriptSizing="dynamic">
  <mat-label>
    {{ schema.title }}
    @if (schema.default) {
      <span>
        {{ schema.default }}
      </span>
    }
  </mat-label>
  <input matInput [formControl]="aFormControl" type="number" step="1" />
  @if (schema.description) {
    <mat-hint>
      {{schema.description}}
    </mat-hint>
  }
</mat-form-field>
